import gql from 'graphql-tag';

export const GET_LESSONS = gql`
  query GetLessonsForAdmin($query: LessonAdminQuery!) {
    getLessonsForAdmin(query: $query) {
      discipline {
        name
        _id
      }
      lessons {
        _id
        name
        image
        audioShortcut
        classes {
          _id
          name
        }
        series {
          _id
          name
        }
        discipline {
          _id
          name
        }
        longContent {
          html
          text
        }
        summary {
          html
          text
        }
      isPublished
      }
    }
  }
`;

export const GET_SINGLE_LESSON = gql`
  query GetLesson($getLessonId: MOID!) {
    getLesson(id: $getLessonId) {
      _id
      name
      image
      audioShortcut
      classes {
        _id
        name
      }
      series {
        _id
        name
      }
      discipline {
        _id
        name
      }
      longContent {
        html
        text
      }
      summary {
        html
        text
      }
    }
  }
`;
